import styled, { css } from 'styled-components';
import mediaQuery from 'styles/mediaQuery';
import theme from 'styles/theme';

export const Container = styled.main``;

export const HeroSection = styled.section`
  padding: 48px 0px;
  display: flex;
  gap: 48px;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  h1 {
    color: ${theme.colors.hostfullyBlue};
    margin-bottom: 0;
  }

  p {
    font-size: 18px;
    margin-bottom: 0;
  }

  button {
    width: fit-content;
  }

  ${mediaQuery.sm} {
    flex-direction: column;
  }
`;

const commonSectionStyles = css`
  padding: 48px 0px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const BenefitsSectionBackground = styled.div`
  background: #d1e7dd;
`;

export const BenefitsSection = styled.section`
  ${commonSectionStyles}
`;

export const BenefitsCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  ${mediaQuery.sm} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQuery.xs} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const BenefitCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-radius: 24px;
  background-color: #fff;
  padding: 18px;

  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
`;

export const ProtectionSection = styled.section`
  ${commonSectionStyles}
`;

export const ProtectionItems = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;

  ${mediaQuery.sm} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const ProtectionItem = styled.div`
  display: flex;
  padding: 30px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;

  border-radius: 24px;
  background: #efeef3;

  color: ${theme.colors.hostfullyBlue};

  ${mediaQuery.sm} {
    &:last-child {
      grid-column: span 2;
    }
  }
`;

export const CallToActionSection = styled.section`
  ${commonSectionStyles}

  & > div {
    display: flex;
    flex-direction: column;
    gap: 18px;

    background: #d1e7dd;
    border-radius: 32px;
    padding: 32px;

    & > div {
      display: flex;
      justify-content: space-between;
      gap: 32px;

      ${mediaQuery.sm} {
        flex-direction: column;
      }
    }
  }
`;

export const ChecklistPoints = styled.div`
  margin: auto 0;

  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;

    gap: 24px;

    li {
      & > svg {
        width: 16px;
        height: 16px;
      }

      display: flex;
      gap: 12px;
      align-items: center;

      color: ${theme.colors.hostfullyBlue};
      font-size: 20px;
    }
  }
`;

export const SectionTitle = styled.h2<{ color: 'blue' | 'green' }>`
  color: ${({ color }) =>
    color === 'blue' ? theme.colors.hostfullyBlue : theme.colors.bgGreen};
  margin: 0;
  font-weight: 600;
  font-size: 32px;
`;

export const SectionSubtitle = styled.p`
  font-size: 20px;
  margin: 0;
  margin-bottom: 8px;
`;
